import { render, staticRenderFns } from "./info-tooltip.vue?vue&type=template&id=4870df13&scoped=true&"
import script from "./info-tooltip.vue?vue&type=script&lang=js&"
export * from "./info-tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870df13",
  null
  
)

export default component.exports